import LabeledMultiSelect from './LabeledMultiSelect';

export default LabeledMultiSelect;
